import { render, staticRenderFns } from "./PolicyBillingDisplay.vue?vue&type=template&id=0a667a56"
import script from "./PolicyBillingDisplay.vue?vue&type=script&lang=js"
export * from "./PolicyBillingDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports